import React, {Component} from 'react';
import PropTypes from 'prop-types';

import nextLEDLogo from '../../../../../assets/images/next-logo-horizontal.png';
import illuminationDisplaysLogo from '../../../../../assets/images/illumination_displays_logo.png';

import './signManufacturerBanner.scss';

const bannerValues = {
  nextled: {
    leftRightColorClass: 'nextled',
    logo: nextLEDLogo,
  },
  'illumination-displays': {
    leftRightColorClass: 'illumination-displays',
    logo: illuminationDisplaysLogo,
  }
};

/**
 * The SignManufacturerBanner component.
 */
class SignManufacturerBanner extends Component {
  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const {signManufacturer} = this.props;

    if (!bannerValues[signManufacturer]) {
      return (<></>);
    }

    const {logo, leftRightColorClass} = bannerValues[signManufacturer];

    return (
      <div className="banner-container">
        <div className={`left-color ${leftRightColorClass}`} />
        <div className="banner-text">
          <img
            className="banner-text-logo"
            src={logo}
            alt={`${signManufacturer} Logo`}
          />
          More credits. Better features. Superior content.</div>
        <div className={`right-color ${leftRightColorClass}`} />
      </div>
    );
  }
}

SignManufacturerBanner.propTypes = {
  signManufacturer: PropTypes.oneOf(['nextled', 'illumination-displays']),
};

export default SignManufacturerBanner;
